/**
 * Bundle Cart — intercept removal of bundled items, remove entire bundle.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var removeEl = e.target.closest('cart-remove-button');
    if (!removeEl) return;

    var row = removeEl.closest('tr');
    if (!row || !row.dataset.bundleId) return; // Not bundled

    var bundleId = row.dataset.bundleId;
    var bundleLabel = row.dataset.bundleLabel || 'this set';

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (!confirm('Remove the entire bundle "' + bundleLabel + '"?\n\nAll items in this set will be removed.')) return;

    removeBundle(bundleId);
  }, true);

  function removeBundle(bundleId) {
    // Find all rows by iterating and checking dataset (more robust than CSS selector)
    var allRows = document.querySelectorAll('tr');
    var indices = [];
    allRows.forEach(function (row) {
      if (row.dataset.bundleId === bundleId) {
        var btn = row.querySelector('cart-remove-button');
        if (btn && btn.dataset.index) {
          indices.push(parseInt(btn.dataset.index, 10));
        }
      }
    });

    if (!indices.length) return;

    // Remove in descending order, one at a time, to avoid index shifting
    indices.sort(function (a, b) { return b - a; });

    function removeNext(i) {
      if (i >= indices.length) {
        window.location.reload();
        return;
      }
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: indices[i], quantity: 0 }),
      }).then(function () {
        removeNext(i + 1);
      }).catch(function () {
        removeNext(i + 1); // Continue even if one fails
      });
    }

    removeNext(0);
  }
})();
